import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LinkButton } from "@perfectserve/library";
export const AccountBreakdown = ({ finalActionsData, totalCalls, selectedOutcome, hoveredSegment, showPlatformData, platformLoading, onOutcomeSelect, onSegmentHover, onLoadPlatformData, }) => {
    const getBackgroundColor = (isSelected, isHovered) => {
        if (isSelected)
            return "#e8f4fd";
        if (isHovered)
            return "#f0f8ff";
        return "white";
    };
    const getBorderStyle = (isSelected) => {
        return isSelected ? "2px solid #374b94" : "2px solid transparent";
    };
    const getBoxShadow = (isSelected, isHovered) => {
        if (isSelected)
            return "0 2px 8px rgba(55, 75, 148, 0.15)";
        if (isHovered)
            return "0 2px 6px rgba(0, 0, 0, 0.08)";
        return "0 1px 3px rgba(0, 0, 0, 0.05)";
    };
    const getOutlineStyle = (isHovered, isSelected) => {
        return isHovered && !isSelected ? "1px solid #b3d9ff" : "none";
    };
    const getTextColor = (isSelected) => {
        return isSelected ? "#1e40af" : "#374151";
    };
    const getFontWeight = (isSelected) => {
        return isSelected ? "600" : "500";
    };
    const getSecondaryTextColor = (isSelected) => {
        return isSelected ? "#1e40af" : "#6b7280";
    };
    const getPrimaryTextColor = (isSelected) => {
        return isSelected ? "#1e40af" : "#374b94";
    };
    return (_jsxs("div", { className: "mb-30", children: [_jsxs("div", { className: "d-flex justify-content-between align-items-center mb-15", children: [_jsx("h3", { className: "m-0 fs-16 fw-600 text-gray-800", children: "Account Breakdown" }), !showPlatformData && (_jsx(LinkButton, { onClick: onLoadPlatformData, className: "fs-12 fw-500", disabled: platformLoading, children: platformLoading ? "Loading..." : "Show platform" }))] }), _jsx("div", { style: { height: "auto", width: "100%" }, children: finalActionsData.map((item) => {
                    const percentage = totalCalls > 0 ? ((item.count / totalCalls) * 100).toFixed(1) : "0";
                    const isSelected = selectedOutcome === item.name;
                    const isHovered = hoveredSegment === item.name;
                    return (_jsxs("div", { className: "d-flex align-items-center justify-content-between rounded-8 mb-8", style: {
                            padding: "10px 14px",
                            backgroundColor: getBackgroundColor(isSelected, isHovered),
                            border: getBorderStyle(isSelected),
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            boxShadow: getBoxShadow(isSelected, isHovered),
                            minHeight: "44px",
                            outline: getOutlineStyle(isHovered, isSelected),
                        }, onClick: () => onOutcomeSelect(item.name), onMouseEnter: () => onSegmentHover(item.name), onMouseLeave: () => onSegmentHover(null), children: [_jsxs("div", { className: "d-flex align-items-center", style: { gap: "10px" }, children: [_jsx("div", { style: {
                                            width: "14px",
                                            height: "14px",
                                            backgroundColor: item.color,
                                            borderRadius: "3px",
                                            flexShrink: 0,
                                        } }), _jsx("span", { className: "fs-13 fw-500", style: {
                                            color: getTextColor(isSelected),
                                            fontWeight: getFontWeight(isSelected),
                                        }, children: item.name })] }), _jsxs("div", { className: "d-flex align-items-center", style: { gap: "12px" }, children: [_jsxs("span", { className: "fs-12 fw-600", style: {
                                            color: getSecondaryTextColor(isSelected),
                                            minWidth: "40px",
                                            textAlign: "right",
                                        }, children: [percentage, "%"] }), _jsx("span", { className: "fs-13 fw-700", style: {
                                            color: getPrimaryTextColor(isSelected),
                                            minWidth: "45px",
                                            textAlign: "right",
                                        }, children: item.count.toLocaleString() }), _jsxs("span", { className: "fs-12 fw-500", style: {
                                            color: getSecondaryTextColor(isSelected),
                                            minWidth: "35px",
                                            textAlign: "right",
                                        }, title: `Median duration: ${item.medianDuration} seconds`, children: [item.medianDuration, "s"] })] })] }, item.name));
                }) })] }));
};
export default AccountBreakdown;
//# sourceMappingURL=AccountBreakdown.js.map